export interface TranscriptMessage {
  id: number
  text: string
  speaker: string
  isFinal: boolean
  component?: React.ReactNode
}

class TranscriptService {
  private idToMessage: Map<number, TranscriptMessage> = new Map()
  private messages: TranscriptMessage[] = []
  private inProgressMsg: TranscriptMessage | null = null

  constructor() {}

  addMessage(message: TranscriptMessage) {
    if (!message.isFinal) {
      this.inProgressMsg = message
      return
    }

    this.idToMessage.set(message.id, message)
    this.inProgressMsg = null

    this.sortMessages()
  }

  sortMessages() {
    this.messages = []
    Array.from(this.idToMessage.keys()).forEach((key) => {
      const msg = this.idToMessage.get(key)
      if (msg != null && msg.isFinal) {
        this.messages.push(msg)
      }
    })
  }

  getReversedMessages() {
    return this.getMessages().reverse()
  }

  getMessages() {
    const copy = this.messages.slice()
    if (this.inProgressMsg != null) {
      copy.push(this.inProgressMsg)
    }

    return copy
  }
}

export default TranscriptService
